import { Wrapper } from "../../components";
import React, { useEffect, useState } from "react";
import {
  Account,
  Billing,
  // Billing,
  Password,
  PersonalSettings,
  Subscription,
} from "../../components/Settings";
import FAQ from "../../components/Settings/Faq/index";
import Feedback from "../../components/Settings/Feedback";
import Security from "../../components/Settings/Security";
import { ASSETS } from "../../utils/config";
import Sidebar from "../../components/NewSidebar";
import Legal from "../../components/Settings/Legal";
import { BillingsPage } from "../../components/Settings/Billing/index";
import { Visibility } from "../../components/Settings/Visibility";
import Storage from "../../components/Storage/Storage";
import ContentModeration from "../../components/ContentModeration";
import { isUserLoggedIn } from "../../utils/helpers";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Settings() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [selectedIndex, setSelectedIndex] = useState("account");

  useEffect(() => {
    // Check if there's a query parameter for 'tab' in the URL
    const urlTabIndex = searchParams.get("tab");

    if (urlTabIndex) {
      setSelectedIndex(urlTabIndex);
    }
  }, [searchParams]);

  const selectIndex = (index) => {
    setSelectedIndex(index);
    // Update URL with the selected tab
    navigate(`/settings?tab=${index}`, { replace: true });
  };

  const options = {
    account: {
      title: "Account",
      // icon: ASSETS.PersonalSettings,
      component: <Account />,
    },
    // account: {
    //   title: "Account",
    //   icon: ASSETS.Account,
    //   component: <Account />,
    // },
    visibility: {
      title: "Visibility",
      component: <Visibility />,
    },
    password: {
      title: "Password",
      // icon: ASSETS.Password,
      component: <Password />,
    },
    subscriptions: {
      title: "Subscription & Billing",
      // icon: ASSETS.Subscription,
      component: <BillingsPage />,
      // <Subscription />,
    },
    // billing: {
    //   title: 'Billing Settings',
    //   icon: ASSETS.Billing,
    //   component: <Billing />,
    // },
    security: {
      title: "Terms & Policies",
      // icon: ASSETS.Security,
      component: <Legal />,
    },
    feedback: {
      title: "Feedback",
      icon: ASSETS.Feedback,
      component: <Feedback />,
    },
    // faq: {
    //   title: 'FAQs',
    //   icon: ASSETS.Faq,
    //   component: <FAQ />,
    // },
    // storage: {
    //   title: "Storage",
    //   icon: ASSETS.Faq,
    //   component: <Storage onUpgradeClick={selectIndex} />,
    // },
    // contentModeration: {
    //   title: 'Content Moderation',
    //   icon: ASSETS.Faq,
    //   component: <ContentModeration />,
    // },
  };

  return (
    <>
      <Wrapper
        style={{ width: "100%" }}
        leftContent={
          <Sidebar
            title="Settings"
            options={options}
            selectedIndex={selectedIndex}
            setSelectedIndex={selectIndex}
            fullSize={false}
          />
        }
        centerContent={options[selectedIndex]?.component}
        isUserProfile={isUserLoggedIn}
      />
      {/* <BlurContent/> */}
      {/* <ContentModeration/> */}
    </>
  );
}
